import React from 'react';
import PropTypes from 'prop-types';
import noop from 'lodash/noop';

import RsTableToolbar from '@Pages/RetroSynthesis/components/RsTableToolbar';
import { ButtonWithIcon } from '@els/els-react--button';
import RsRoutesSelectionBar from '@Pages/RetroSynthesis/components/RsRoutesSelectionBar/RsRoutesSelectionBar';
import { useHistory } from 'react-router-dom';
import LegendTooltipContent from '@Pages/RetroSynthesis/ProjectRoute/ProjectRouteToolbar/components/LegendTooltipContent';
import { RsRoute } from '@Pages/RetroSynthesis/routes';
import HoverTooltip from '@Components/HoverTooltip';
import ReactDOMServer from 'react-dom/server';
import ConditionsButton from './components/ConditionsButton';

import './ProjectRouteToolbar.scss';

function ProjectRouteToolbar({ projectId, routeId, conditionsIsShown, setConditionsIsShown, onExport, routeType }) {
  const history = useHistory();
  const routeClickHandler = (route) => {
    history.push(RsRoute.getProjectRouteTreeViewLink(projectId, route.id));
  };

  return (
    <RsTableToolbar className="rs-route-toolbar">
      <div className="rs-table-toolbar__left-controls">
        <ButtonWithIcon
          layout="vertical"
          sprite="Upload"
          type="borderless"
          size="small"
          className="e2e-rs-toolbar-button-export"
          onClick={onExport}>
          Export
        </ButtonWithIcon>
        <HoverTooltip
          id="project-route-toolbar-legend"
          tooltipPlace="bottom-end"
          trigger="click"
          className="legend-tooltip"
          tooltip={ReactDOMServer.renderToString(<LegendTooltipContent />)}>
          <ButtonWithIcon
            layout="vertical"
            sprite="InformationOutlineCircle"
            type="borderless"
            size="small"
            className="e2e-rs-toolbar-button-legend"
            onClick={noop}
            data-for="project-route-toolbar-legend"
            data-event="click"
            data-tip>
            Legend
          </ButtonWithIcon>
        </HoverTooltip>
      </div>
      <div className="rs-table-toolbar__center-controls">
        <RsRoutesSelectionBar activeRoute={routeId} setActiveRoute={routeClickHandler} projectId={projectId} />
      </div>
      <div className="rs-table-toolbar__right-controls rs-route-toolbar__right-controls">
        <ConditionsButton conditionsIsShown={conditionsIsShown} setConditionsIsShown={setConditionsIsShown} routeType={routeType} />
      </div>
    </RsTableToolbar>
  );
}

ProjectRouteToolbar.defaultProps = {
  onExport: () => null,
};

ProjectRouteToolbar.propTypes = {
  onExport: PropTypes.func,
  setConditionsIsShown: PropTypes.func,
  routeType: PropTypes.string,
  projectId: PropTypes.string,
  routeId: PropTypes.string,
  conditionsIsShown: PropTypes.bool,
};

export default ProjectRouteToolbar;
